import backendRequest from '../../../services/api/backendRequest'
import { BudgetComment } from '../types'
import budgetCommentsEndpoints from '../api/budgetCommentsEndpoints'

export interface FetchCommentsParams {
  companyId: string
  budgetingScenarioId?: number | null
  dimensions?: string
}

export const fetchComments = ({ companyId, budgetingScenarioId, dimensions }: FetchCommentsParams) =>
  backendRequest<BudgetComment[]>({
    method: 'GET',
    url: budgetCommentsEndpoints.list(companyId),
    params: {
      budgetingScenarioId,
      dimensions
    }
  })

// Comment mutations
export interface CreateCommentParams {
  companyId: string
  comment: Omit<BudgetComment, 'id' | 'companyId' | 'userId' | 'createdAt' | 'updatedAt' | 'dimensionId'>
  dimensions?: string
  budgetingScenarioId?: number | null
}

export const createComment = ({ companyId, comment, dimensions, budgetingScenarioId }: CreateCommentParams) => {
  console.log('📤 Creating comment - Request:', {
    url: budgetCommentsEndpoints.create(companyId),
    data: comment,
    params: { budgetingScenarioId, dimensions }
  })

  return backendRequest<BudgetComment>({
    method: 'POST',
    url: budgetCommentsEndpoints.create(companyId),
    data: comment,
    params: {
      budgetingScenarioId,
      dimensions
    }
  })
}

export interface UpdateCommentParams {
  companyId: string
  commentId: number
  comment: Partial<Omit<BudgetComment, 'id' | 'companyId' | 'userId' | 'createdAt' | 'updatedAt'>>
  budgetingScenarioId?: number | null
}

export const updateComment = ({ companyId, commentId, comment, budgetingScenarioId }: UpdateCommentParams) =>
  backendRequest<BudgetComment>({
    method: 'PUT',
    url: budgetCommentsEndpoints.detail(companyId, commentId),
    data: comment,
    params: {
      budgetingScenarioId
    }
  })

export interface DeleteCommentParams {
  companyId: string
  commentId: number
  budgetingScenarioId?: number | null
}

export const deleteComment = ({ companyId, commentId, budgetingScenarioId }: DeleteCommentParams) =>
  backendRequest<void>({
    method: 'DELETE',
    url: budgetCommentsEndpoints.detail(companyId, commentId),
    params: {
      budgetingScenarioId
    }
  })
